import { render, staticRenderFns } from "./activeProfileChart.vue?vue&type=template&id=2ec3ee14&scoped=true"
import script from "./activeProfileChart.vue?vue&type=script&lang=js"
export * from "./activeProfileChart.vue?vue&type=script&lang=js"
import style0 from "./activeProfileChart.vue?vue&type=style&index=0&id=2ec3ee14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec3ee14",
  null
  
)

export default component.exports